import { createFeature, createReducer, on } from '@ngrx/store';
import {
  PricingTableDialogEffectActions,
  PricingTableDialogActions,
} from './pricing-table-dialog.actions';
import { EntityServiceError } from '../shared/errors/entity-service.error';
import { PricingTableSession } from './models/pricing-table-dialog.model';

interface State {
  pricingTableSession: PricingTableSession;
  error: EntityServiceError;
}

const initialState: State = {
  pricingTableSession: null,
  error: null,
};

export const pricingTableDialogFeature = createFeature({
  name: 'pricing table dialog',
  reducer: createReducer(
    initialState,
    on(PricingTableDialogActions.opened, PricingTableDialogActions.closed, (state) => ({
      ...state,
      pricingTableSession: null,
      error: null,
    })),
    on(
      PricingTableDialogEffectActions.loadPricingTableSucceeded,
      (state, { pricingTableSession }) => ({
        ...state,
        pricingTableSession,
      }),
    ),
    on(PricingTableDialogEffectActions.loadPricingTableErrored, (state, { error }) => ({
      ...state,
      error,
    })),
  ),
});
